import actionTypes from './GTMWTWTI01ActionType';

/**
 * 作業時間照会
 */
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 作業時間照会を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getWorkingtimeInquiry = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_WORKINGTIME_INQUIRY_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_WORKINGTIME_INQUIRY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_WORKINGTIME_INQUIRY_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_WORKINGTIME_INQUIRY_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
